<template>
  <form class="FormsHandbookForm" name="forms-handbook" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12" lg="4">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <BLayoutExpansion title="Список" class="my-4">
      <div class="caption">
        Скопируйте и вставьте cписок.
        <br>Каждый элемент списка должен быть в отдельной строке.
      </div>

      <BEditor
        v-model="model"
        :extensions="[]"
        :editor-props="editorProps"
        min-height="420px"
        dense
        class="FormsHandbookForm__editor"
      />
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'

import {
  BEditor,
  fromHTML,
  editorProps,
} from '@/views/FormTemplates/components/FormTemplatesForm/FormTemplatesFormEditor.vue'


const createDefaultData = () => ({
  // id
  name: '',
  handbook_values: [],
  // created_at
  // updated_at
})

export default {
  name: 'FormsHandbookForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BEditor,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    editorProps,
    model: '',
  }),
  watch: {
    data: {
      immediate: true,
      handler(value) {
        this.model = value.handbook_values.join('</p><p>').replace(/(.*)/, '<p>$1</p>')
      },
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,
        handbook_values: fromHTML(this.model),
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>

<style lang="scss">
.FormsHandbookForm {
  &__editor {
    p {
      margin: 0 !important;
    }
  }
}
</style>
